import { Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

export default function DialogHeader() {
	const { translate } = useLocales();

	return (
		<Stack sx={{ p: 3, pb: 0 }} gap={1}>
			<Typography variant='subtitle1' fontSize={21}>
				{translate("organization.invite_new_user")}
			</Typography>
			<Typography variant='body2' color='text.secondary'>
				{translate("organization.invite_new_user_description")}
			</Typography>
		</Stack>
	);
}
